import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import {
  FormControl,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatSnackBar, MatSnackBarModule } from '@angular/material/snack-bar';
import { Router } from '@angular/router';
import { finalize } from 'rxjs/operators';
import { SuccessSnackbar } from '../../../components/snackbar/success-snackbar/success-snackbar';
import { FaqService } from '../../../services/faq/faq.service';

@Component({
  standalone: true,
  selector: 'app-faq-contact',
  imports: [
    FormsModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatInputModule,
    CommonModule,
    MatSnackBarModule,
    MatButtonModule,
    MatProgressSpinnerModule,
  ],
  templateUrl: './faq-contact.component.html',
  styleUrl: './faq-contact.component.scss',
})
export class FaqContactComponent {
  public contatoForm: FormGroup;
  public isLoading = false;

  constructor(
    private _snackBar: MatSnackBar,
    private faqService: FaqService,
    private router: Router
  ) {
    this.contatoForm = new FormGroup({
      mensagem: new FormControl('', [
        Validators.required,
        Validators.maxLength(1000),
      ]),
    });
  }

  sendContact(): void {
    if (this.contatoForm.invalid || this.isLoading) {
      return;
    }

    this.isLoading = true;
    const mensagem = this.contatoForm.get('mensagem')?.value;

    this.faqService
      .postFaqContact(mensagem)
      .pipe(
        finalize(() => {
          this.isLoading = false;
        })
      )
      .subscribe({
        next: (response) => {
          this.showSuccessSnackbar('Sua mensagem foi enviada com sucesso!');
          this.contatoForm.setErrors(null);
          this.contatoForm.reset();
        },
        error: (error) => {
          console.error('Erro ao enviar mensagem:', error);
        },
      });
  }

  showSuccessSnackbar(message: string): void {
    this._snackBar.openFromComponent(SuccessSnackbar, {
      data: { message: message },
      duration: 5000,
      horizontalPosition: 'center',
      verticalPosition: 'bottom',
    });
  }
}
